import { useEffect, useState } from "react";
import { useCentralStore } from "../../store/Central";
import { Logger } from "../../../../lib/logger/Logger";
import {
	ActivityEntityType,
	ClientEntityType,
} from "../../../../lib/supabase/supabaseTypes";
import { Avatar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getClientAvatar } from "./utils";
import { showNotification } from "../../store/Central/selectors";

export const TEMPLATE_CODE = "template-8ed86c65-28a3-4627-a4b0-a68ad61f5876";

type ClientsWithShared = ClientEntityType & {
	connect_relationships: { shared: ActivityEntityType[] } | null;
};

export const ChatsPage = () => {
	//const { profile } = useCentralStore.getState();
	const [clients, setClients] = useState<
		(ClientEntityType & {
			connect_relationships: { shared: ActivityEntityType[] } | null;
		})[]
	>([]);

	const getClients = async () => {
		Logger.log("getClients");
		showNotification({
			message: "Die Funktion ist vorübergehend deaktiviert",
			type: "error",
		});
		setClients([]);
		return;
/* 		if (!profile?.organization_id) return;
		const { data, error } = await supabase
			.from(SupabaseTableEnum.CLIENTS)
			.select(
				`*, ${SupabaseTableEnum.CONNECT_RELATIONSHIPS}(*, ${SupabaseTableEnum.SHARED}(*))`
			)
			.neq("code", TEMPLATE_CODE) // TEMPLATE_CODE is the code of the dummy client for template
			.eq("organization_id", profile?.organization_id)
			.order("created_at", {
				referencedTable: "connect_relationships.shared",
				ascending: false,
			});

		if (error) {
			Logger.error(error, {}, "Error fetching clients");
			return;
		}

		setClients(data); */
	};

	useEffect(() => {
		getClients();
	}, []);

	return (
		<div className="flex flex-col gap-2">
			{clients.map((cl) => (
				<ClientRow client={cl} key={cl.id} />
			))}
		</div>
	);
};

const ClientRow = ({ client }: { client: ClientsWithShared }) => {
	const { profile } = useCentralStore.getState();
	const [avatar, setAvatar] = useState("");
	const navigate = useNavigate();

	useEffect(() => {
		const getAvatar = async () => {
			if (!client.avatar_path) return;
			const avatar_img = await getClientAvatar(
				client.avatar_path,
				profile?.organization_id as string
			);
			if (!avatar_img) return;
			setAvatar(avatar_img);
		};

		getAvatar();
	}, []);

	if (!client.connect_relationships) {
		return;
	}

	const totalShared = client.connect_relationships?.shared.length ?? 0;
	return (
		<div
			onClick={() => {
				navigate(`/chat/${client.id}`);
			}}
			className="flex justify-between cursor-pointer my-1 gap-2 bg-gray-100 p-2 rounded"
		>
			<Avatar src={avatar} />
			<div className="w-full">
				<div>
					{client.first_name} {client.last_name}
				</div>
				<div>
					{
						client.connect_relationships?.shared[totalShared - 1]
							?.activity_type
					}
				</div>
			</div>
			{client.connect_relationships?.shared[totalShared - 1]
				?.created_at && (
				<div className="text-xs text-gray-500">
					{new Date(
						client.connect_relationships?.shared[
							totalShared - 1
						]?.created_at
					).toLocaleDateString("de-CH")}
				</div>
			)}
		</div>
	);
};
